import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { MarketFanExplorationComponent } from './market-fan-exploration/component/market-fan-exploration/market-fan-exploration.component';
import { MarketInsightsComponent } from './market-insights/component/market-insights/market-insights.component';
import { MarketOverviewComponent } from './market-overview/component/market-overview/market-overview.component';
import { MarketingRequestsComponent } from './marketing-requests/component/marketing-requests/marketing-requests.component';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { LoginComponent } from './shared/components/login/login.component';
import { HomeComponent } from './home/component/home/home.component';
import { MatchSchedulesComponent } from './home/component/match-scheduling/match-schedules.component';
import { ResourcesComponent } from './resources/component/resources/resources.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'match-schedules',
        component: MatchSchedulesComponent,
      },
      {
        path: 'market-overview',
        component: MarketOverviewComponent,
      },
      {
        path: 'market-fan-exploration/edit/:queryType/:queryId/:executionid',
        component: MarketFanExplorationComponent,
      },
      {
        path: 'market-fan-exploration',
        component: MarketFanExplorationComponent,
      },
      {
        path: 'market-insights',
        component: MarketInsightsComponent,
      },
      {
        path: 'marketing-requests',
        component: MarketingRequestsComponent,
      },
      {
        path: 'resources',
        component: ResourcesComponent,
      },
      {
        path: '**',
        redirectTo: '/home',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
